import axios from 'axios';

// Dedicated DevSecOps API client so we can talk to the DevSecOps backend
// without changing the primary API_BASE_URL used by the rest of the app.
//
// Order of precedence:
// 1) REACT_APP_DEVSECOPS_API_URL (build-time env for frontend)
// 2) window.ENV.DEVSECOPS_API_URL (runtime config if injected)
// 3) Fallback to the known Railway DevSecOps backend URL

const DEVSECOPS_API_BASE_URL =
  process.env.REACT_APP_DEVSECOPS_API_URL ||
  (window as any).ENV?.DEVSECOPS_API_URL ||
  (window as any).ENV?.API_URL ||
  (process.env.NODE_ENV === 'development' 
    ? 'http://localhost:3002/api/v1'
    : 'https://e-unify-ai-backend-production-458e.up.railway.app/api/v1');

export const devsecopsApi = axios.create({
  baseURL: DEVSECOPS_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  },
  // Enable credentials for local development to support cookie-based auth
  withCredentials: process.env.NODE_ENV === 'development'
});
